import { motion } from 'framer-motion';
import FaqIllustration from '../../../../../assets/App_Img/landing_faq_illustration.png';

const FaqIllustrationCard = () => {
  return (
    <div className="flex-1 w-full flex items-center justify-center relative">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-[280px] sm:max-w-sm md:max-w-md aspect-square bg-gradient-to-br from-[#e0f2fe] to-[#f0fdfa] rounded-2xl sm:rounded-3xl md:rounded-[3rem] flex flex-col items-center justify-center relative shadow-inner overflow-hidden border-2 border-white"
      >
        <div className="absolute top-10 left-10 w-20 h-20 bg-white/40 rounded-full blur-xl" />
        <div className="absolute bottom-20 right-10 w-32 h-32 bg-white/40 rounded-full blur-xl" />

        <img
          src={FaqIllustration}
          alt="FAQ Illustration"
          className="w-[90%] h-[90%] object-contain z-10 hover:scale-105 transition-transform duration-500"
          style={{ mixBlendMode: 'darken' }}
        />
      </motion.div>
    </div>
  );
};

export default FaqIllustrationCard;
